//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {
		mapState
	} from 'vuex'
	import {
		boxList
	} from '@/api'
	//专区箱子
	export default {
		name: 'home',
		components: {
			sTswiper: () => import('./components/swiper/index.vue'),
			// notice: () => import('./components/notice/index.vue'),
		},
		data() {
			return {
				Height: 0,
				swiperShow: false,
				box_list: []
			}
		},

		created() {
		},
		methods: {
			toCaseList(){
					this.$router.push({
						path: '/official/case'
					})
			},

			close() {
				this.swiperShow = false
			},

			to_open(id) {
					this.$router.push({
						path: '/official/open',
						query: {
							id: id
						}
					})
			},
		},
		computed: {
		},
		
		beforeDestroy() {
		},
		watch: {
			
			swiperShow(v) {
				sessionStorage.setItem('swiperShow', v)
			}
		}
	}
